// extracted by mini-css-extract-plugin
export default {"title":"Header_title__8RkNB","block":"Header_block__Tjzmu","line":"Header_line__xyj1J"};